module.exports = "/images/itineraryBG.png?a09d983492fcdec4df114dcec7ab5827";